type MentionType =
  | 'portfolio'
  | 'project'
  | 'board'
  | 'sprint'
  | 'goal'
  | 'outcome'
  | 'initiative'
  | 'epic'
  | 'dashboard'
  | 'repository';

const CATEGORY_ORDER: MentionType[] = [
  'goal',
  'outcome',
  'initiative',
  'epic',
  'portfolio',
  'project',
  'board',
  'sprint',
  'repository',
  'dashboard',
];

const CATEGORY_ICONS: Record<MentionType, string> = {
  portfolio: 'cases',
  project: 'inventory_2',
  board: 'space_dashboard',
  sprint: 'calendar_month',
  goal: 'flag',
  outcome: 'checklist',
  initiative: 'event_note',
  epic: 'bolt',
  dashboard: 'dashboard',
  repository: 'code',
};

interface MentionItem {
  id: string;
  name: string;
  type: MentionType;
  parentName?: string; // For boards, this is the project name; for sprints, this is the board name
  parentId?: string; // For sprints, this is the board id
}

interface SelectedMention extends MentionItem {
  startIndex: number;
  endIndex: number;
}

export { CATEGORY_ICONS, CATEGORY_ORDER };
export type { MentionItem, MentionType, SelectedMention };
